import gql from 'graphql-tag';

export default gql`
  mutation updateDesignProfile($id: Int!, $set: design_profiles_set_input!) {
    update_design_profiles_by_pk(pk_columns: { profile_id: $id }, _set: $set) { profile_id }
  }
`;
